import * as React from "react";
import { ProductResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { formatCurrency, truncateName } from "../helpers/format_currency";

export type BestsellerItems = {
  bestsellers: ProductResult[];
};

const starPixels = (rating: number) => {
  const base = (rating * 2 * 50) / 100;
  return base + (base / 5) * 3 + 1;
};
export const Bestsellers = (bestsellers: BestsellerItems): JSX.Element => (
  <div id="bestsellers">
    {bestsellers.bestsellers.length > 0 && (
      <>
        <h3>Nejprodávanější</h3>
        <table>
          <tbody>
            {bestsellers.bestsellers.map((bestseller, index) => (
              <tr key={bestseller.catalogId}>
                <td>
                  <div className="row index">{index + 1}</div>
                </td>
                <td className="product-image">
                  <a href={bestseller.linkPath}>
                    <img src={bestseller.imageUrl} alt={bestseller.fullName} />
                  </a>
                </td>
                <td className="product-info">
                  <div className="row higher">
                    <a href={bestseller.linkPath}>
                      {truncateName(bestseller.fullName, 60)}
                    </a>
                    <span className="stars small-stars rating">
                      <span
                        style={{ width: starPixels(bestseller.averageRating) }}
                        className="full"
                      ></span>
                    </span>
                    <span className="availability">
                      {bestseller.currentSupplier && (
                        <strong className="available-quantity">
                          {bestseller.currentSupplier.stockQuantityLabel}
                        </strong>
                      )}
                    </span>
                  </div>
                  <div className="row">{bestseller.summary}</div>
                </td>
                <td>
                  <div className="recommended">
                    {/*<div className="row higher">*/}
                    {/*  <div className="strike">17&nbsp;790&nbsp;Kč</div>*/}
                    {/*</div>*/}
                  </div>
                  <div className="row">
                    <div className="current-price">
                      {formatCurrency(bestseller.price)}
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )}
  </div>
);
